import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const initialState: { value: Record<string, string | undefined | null> } = {
  value: {}
}

const cacheSlice = createSlice({
  name: "cache_slice",
  initialState,
  reducers: {
    push: (state, action: PayloadAction<{ key: string, value: string | null }>) => {
      state.value[action.payload.key] = action.payload.value
    }
  }
})

export const { push } = cacheSlice.actions
export const cache_slice = cacheSlice.reducer